import { isTypeTimelineSection } from '@platform/contentful';
import { Entry } from 'contentful';
import { getFullWidthBackgroundStyles } from './util/utils';
import cx from 'classix';
import Divider from './util/Divider';
import MarkdownText from './util/MarkdownText';
import ContentfulTimelineItem from './ContentfulTimelineItem';

const ContentfulTimelineSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeTimelineSection(entry)) {
    return null;
  }

  return (
    /* The entry does have a background color set, but it seems to be unused. */
    <div className={cx(getFullWidthBackgroundStyles(entry), 'relative !bg-blue-50')}>
      <div
        className='absolute left-0 top-0 bg-no-repeat bg-left bg-cover h-screen w-full'
        style={{
          backgroundImage: `url(${entry.fields.headerImage?.fields.file?.url}?fit=fill&w=1280&h=720)`,
        }}
      />
      <div className='box-content relative -mx-2 sm:mx-auto mt-[25vh] sm:max-w-2xl xl:max-w-4xl flex flex-col bg-white px-4 sm:px-14 py-10 sm:py-20 items-center'>
        <h1 className='my-3 font-header text-4xl sm:text-5xl leading-11 sm:leading-14 font-bold text-gray-500'>
          {entry.fields.header}
        </h1>
        <h2 className='mb-5 font-header text-xl sm:text-2xl leading-6 sm:leading-7 font-medium text-gray-400'>
          {entry.fields.subHeader}
        </h2>
        <Divider />
        <div className='text-left mb-4 sm:mb-8'>
          {/* This is not a WYSIWYG section, but we this component still applies tye .wysiwyg-section styles */}
          <MarkdownText text={entry.fields.description ?? ''} />
        </div>
        {entry.fields.timelineItems?.map((item, i) => (
          <ContentfulTimelineItem
            key={item?.sys.id}
            entry={item}
            itemNumber={i}
            isLastItem={i + 1 === entry.fields.timelineItems?.length}
          />
        ))}
      </div>
    </div>
  );
};

export default ContentfulTimelineSection;
